import { StyleType } from '../types';

export const style: StyleType = `
.p-checkbox-group {
    display: inline-flex;
}
`;
